












import { Component, Vue } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import NewsletterForm from "./Components/NewsletterForm.vue";
import Newsletter from "@/models/newsletter";
import NewslettersAPI from "@/services/newsletters";

@Component({
  components: { NewsletterForm },
})
export default class EditNewsletter extends Vue {
  model: Newsletter | null = null;
  loading = true;

  created(): void {
    if (this.$route.params.id) this.getRecord();
  }

  async getRecord(): Promise<void> {
    try {
      const r = await NewslettersAPI.get(this.$route.params.id);
      this.model = new Newsletter(r);
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  async save(model: Newsletter): Promise<void> {
    LayoutModule.showLoader();
    try {
      await NewslettersAPI.update(model);
      LayoutModule.setAlerts({
        text: this.$t("newsletters.responses.success_update").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "newsletters" });
  }

  async sync(model: Newsletter): Promise<void> {
    try {
      await NewslettersAPI.syncrhonize(model.id);
      LayoutModule.setAlerts({
        text: this.$t("newsletters.responses.success_sync").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
  }
}
